module.exports = __webpack_public_path__ + "static/media/achievement-bg.67884831.png";